export default "__VITE_ASSET__LoXvYvvz__"